const PassengerType = {
    ADULT : 1,
    CHILD : 2,
    INFANT : 3
}

export default PassengerType;